@if ((searchResult$$ | async) === null) {
  <mat-card-header>
    <mat-card-title class="search-title">Resubscribe email recipients</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <EXP__glxy-wrap>
      <mat-form-field>
        <mat-label>What kind of sender?</mat-label>
        <mat-select id="sender-type" placeholder="Sender Type" [(value)]="senderType">
          <mat-option value="business">Business</mat-option>
          <mat-option value="partner">Partner</mat-option>
          <mat-option value="product">Product</mat-option>
        </mat-select>
      </mat-form-field>
    </EXP__glxy-wrap>
    @if (senderType !== '') {
      <form [formGroup]="searchForm">
        <glxy-form-field>
          <input matInput placeholder="Recipient Email" formControlName="email" />
        </glxy-form-field>
        @if (senderType === 'partner') {
          <glxy-form-field [glxyPopover]="helpPopover">
            <input matInput placeholder="Partner ID" formControlName="senderId" />
            <mat-icon matSuffix (click)="openHelpNote()">help_outline</mat-icon>
          </glxy-form-field>
        }
        @if (senderType === 'business') {
          <glxy-form-field>
            <input matInput placeholder="Business ID" formControlName="senderId" />
          </glxy-form-field>
        }
        <glxy-popover
          #helpPopover
          [isOpen]="isHelpPopoverOpen"
          [positions]="[pos]"
          (backdropClick)="closeHelpNote()"
          [hasArrow]="true"
        >
          If the recipient you are searching for is not partner specific, leave this field blank
          <glxy-popover-actions>
            <button mat-stroked-button color="primary" (click)="closeHelpNote()">Close</button>
          </glxy-popover-actions>
        </glxy-popover>
        <button mat-flat-button color="primary" class="search-button" (click)="searchForUnsubscribed()">
          @if ((loading$$ | async) === false) {
            Search
          } @else {
            <mat-spinner class="loading" [diameter]="30" />
          }
        </button>
      </form>
    }
  </mat-card-content>
} @else {
  @if (searchResult$$ | async; as result) {
    <div class="result-container">
      <glxy-alert type="warning">
        Re-subscribing a recipient requires their consent.
        <br />
        Be absolutely sure you have this before continuing!
      </glxy-alert>
      <div class="result-details">
        <div>Recipient Email: {{ result.email }}</div>
        @if (result.senderId !== '' && senderType === 'partner') {
          <div>Partner ID: {{ result.senderId }}</div>
        }
        @if (result.senderId !== '' && senderType === 'business') {
          <div>Business ID: {{ result.senderId }}</div>
        }
      </div>
      <form [formGroup]="searchForm">
        <mat-checkbox formControlName="consent">I have the recipient's consent</mat-checkbox>
      </form>
      <div class="actions">
        <button mat-flat-button color="warn" (click)="goBack()">Go back</button>
        <button
          mat-flat-button
          color="primary"
          (click)="resubscribeRecipient(result)"
          [disabled]="!searchForm.get('consent').value"
        >
          @if ((loading$$ | async) === false) {
            Resubscribe
          } @else {
            <mat-spinner class="loading" [diameter]="30" />
          }
        </button>
      </div>
    </div>
  }
}
